import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmailVerificationRoutingModule } from './email-verification-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EmailVerificationRoutingModule
  ]
})
export class EmailVerificationModule { }
